// @generated by protobuf-ts 2.11.1 with parameter generate_dependencies,long_type_number,ts_nocheck,optimize_code_size
// @generated from protobuf file "c1/api/notify/v1/notify.proto" (package "c1.api.notify.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
/**
 * @generated from protobuf message c1.api.notify.v1.NotifyRequest
 */
export interface NotifyRequest {
    /**
     * @generated from protobuf field: repeated string tokens = 1
     */
    tokens: string[];
    /**
     * @generated from protobuf field: string offset = 2
     */
    offset: string;
}
/**
 * @generated from protobuf message c1.api.notify.v1.NotifyResponse
 */
export interface NotifyResponse {
    /**
     * @generated from protobuf field: string offset = 1
     */
    offset: string;
    /**
     * @generated from protobuf oneof: msg
     */
    msg: {
        oneofKind: "alive";
        /**
         * @generated from protobuf field: c1.api.notify.v1.KeepAlive alive = 100
         */
        alive: KeepAlive;
    } | {
        oneofKind: "changed";
        /**
         * @generated from protobuf field: string changed = 101
         */
        changed: string;
    } | {
        oneofKind: undefined;
    };
}
/**
 * @generated from protobuf message c1.api.notify.v1.KeepAlive
 */
export interface KeepAlive {
}
// @generated message type with reflection information, may provide speed optimized methods
class NotifyRequest$Type extends MessageType<NotifyRequest> {
    constructor() {
        super("c1.api.notify.v1.NotifyRequest", [
            { no: 1, name: "tokens", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "1", maxItems: "1024", unique: true, items: { string: { minBytes: "1", maxBytes: "8192" } } } } } },
            { no: 2, name: "offset", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "8192" } } } }
        ]);
    }
    create(value?: PartialMessage<NotifyRequest>): NotifyRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.tokens = [];
        message.offset = "";
        if (value !== undefined)
            reflectionMergePartial<NotifyRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: NotifyRequest): NotifyRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated string tokens */ 1:
                    message.tokens.push(reader.string());
                    break;
                case /* string offset */ 2:
                    message.offset = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: NotifyRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated string tokens = 1; */
        for (let i = 0; i < message.tokens.length; i++)
            writer.tag(1, WireType.LengthDelimited).string(message.tokens[i]);
        /* string offset = 2; */
        if (message.offset !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.offset);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.notify.v1.NotifyRequest
 */
export const NotifyRequest = new NotifyRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class NotifyResponse$Type extends MessageType<NotifyResponse> {
    constructor() {
        super("c1.api.notify.v1.NotifyResponse", [
            { no: 1, name: "offset", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 100, name: "alive", kind: "message", oneof: "msg", T: () => KeepAlive },
            { no: 101, name: "changed", kind: "scalar", oneof: "msg", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<NotifyResponse>): NotifyResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.offset = "";
        message.msg = { oneofKind: undefined };
        if (value !== undefined)
            reflectionMergePartial<NotifyResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: NotifyResponse): NotifyResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string offset */ 1:
                    message.offset = reader.string();
                    break;
                case /* c1.api.notify.v1.KeepAlive alive */ 100:
                    message.msg = {
                        oneofKind: "alive",
                        alive: KeepAlive.internalBinaryRead(reader, reader.uint32(), options, (message.msg as any).alive)
                    };
                    break;
                case /* string changed */ 101:
                    message.msg = {
                        oneofKind: "changed",
                        changed: reader.string()
                    };
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: NotifyResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string offset = 1; */
        if (message.offset !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.offset);
        /* c1.api.notify.v1.KeepAlive alive = 100; */
        if (message.msg.oneofKind === "alive")
            KeepAlive.internalBinaryWrite(message.msg.alive, writer.tag(100, WireType.LengthDelimited).fork(), options).join();
        /* string changed = 101; */
        if (message.msg.oneofKind === "changed")
            writer.tag(101, WireType.LengthDelimited).string(message.msg.changed);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.notify.v1.NotifyResponse
 */
export const NotifyResponse = new NotifyResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class KeepAlive$Type extends MessageType<KeepAlive> {
    constructor() {
        super("c1.api.notify.v1.KeepAlive", []);
    }
    create(value?: PartialMessage<KeepAlive>): KeepAlive {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<KeepAlive>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: KeepAlive): KeepAlive {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: KeepAlive, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.notify.v1.KeepAlive
 */
export const KeepAlive = new KeepAlive$Type();
/**
 * @generated ServiceType for protobuf service c1.api.notify.v1.Notify
 */
export const Notify = new ServiceType("c1.api.notify.v1.Notify", [
    { name: "Notify", serverStreaming: true, options: { "authz.method": { role: "VIEWER" } }, I: NotifyRequest, O: NotifyResponse }
]);
